import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { required, maxLength, numeric, email as emailVal } from 'vuelidate/lib/validators';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import KEYS from '@/values/keys';
import { VERIFY_TYPES, AUTH_EVENTS, PUBLIC_RATE_LIMIT_WAIT_SECONDS } from '@/auth/values/auth.values';
import EdRegisterValidatePhoneComponent from '@/auth/components/ed-register/ed-register-validate-phone/ed-register-validate-phone.component.vue';
import { Store, STORE } from '@/core/store/core.store';
import { i18n } from '@/core/lang/core.i18n';
import STATES from '@/core/values/states';
import { ZipCodeService } from '@/services/zipcode.service';
import { StaffService } from '@/tools/services/staff.service';
import { IUserInformation } from '@/tools/interfaces/userinformation-interface'
import { MyInfoServices } from '@/tools/services/myinfo.service';
import { User } from '@/core/models/user.model';


@Component({
    name: 'ed-my-info-admin',
    components: {
      EdRegisterValidatePhoneComponent
    }
  })
export default class EdMyInfoAdminComponent extends Vue {

    /* Data */
  public form: any = [];
  public initialForm: any = [];
  public saving: boolean = false;
  public userInformation: IUserInformation = null;
  public cities: any = [];
  public personId: number;
  public hasCorrectZipCode: boolean = false;
  public zipCodeLoading: boolean = false;
  public username: string = ''
  public verifyType: any = null;
  public verifyTypes: any = VERIFY_TYPES;
  public validatedPhone: any = null;
  public currentUserEmail: any = null;
  public emailAlreadyExists: boolean = false;

  get countries(): any[] {
    return Store.state.ToolsStore.countries.map(el => { return { text: el.name, value: el.code } });
  }

  get required() {
    return [v => !!v || this.$t('errors.required')]
  }

  get compareForms(): boolean {
    for(var key in this.form){
      if(this.initialForm[key]!=undefined && (this.form[key].value != this.initialForm[key].value) && key != undefined){
        return false;
        }
      }
    return true;
  }

  get requiredPhoneValidation(): boolean {
    if(this.form.personPhoneNumber.value != '' && this.validatedPhone !== this.form.personPhoneNumber.value) {
      this.form.setValid('personPhoneVerificationCode', false);
      this.form.setValid('personPhoneVerificationId', false);

      return true;
    } else {
      this.form.setValid('personPhoneVerificationCode', true);
      this.form.setValid('personPhoneVerificationId', true);

      return false;
    }
  }

  /* Methods */
  private init(username:string='', email:string='', firstName: string = '', middleName: string = '', lastName: string = '', phoneNumber: string = '', ext: string = '', 
            addressLine1: string = '', adressLine2: string = '', adressLine3: string = '' , 
            state: string = '', city: string= '' , zipCode: string = '', countryCode: string=''): void {
    this.form = EdFormModel([
      EdInputModel('username', username, null, true),
      EdInputModel('email', email, {required, emailVal}, true),
      EdInputModel('personFirstName', firstName, {required, maxLength: maxLength(60)}, true),
      EdInputModel('personMiddleName', middleName, {maxLength: maxLength(60)}, true),
      EdInputModel('personLastName', lastName, {required, maxLength: maxLength(60)}, true),
      EdInputModel('personPhoneNumber', phoneNumber, {required, maxLength: maxLength(15)}, true),
      EdInputModel('personAddress1', addressLine1, {required, maxLength: maxLength(200)}, true),
      EdInputModel('personAddress2', adressLine2, {maxLength: maxLength(200)}, true),
      EdInputModel('personAddress3', adressLine3, {maxLength: maxLength(200)}, true),
      EdInputModel('personZipCode', zipCode, {numeric, required}, true),
      EdInputModel('personCountryCode', countryCode),
      EdInputModel('personCity', city),
      EdInputModel('personState', state, {required}),
      EdInputModel('personPhoneNumberExt', ext, {numeric, maxLength: maxLength(7)}, true),
      EdInputModel('personPhoneVerificationCode', ''),
      EdInputModel('personPhoneVerificationId', '')
    ]);
  }

  setFields(): void {
    this.init(
      this.username,
      this.userInformation.email,
      this.userInformation.personFirstName,
      this.userInformation.personMiddleName ?? '',
      this.userInformation.personLastName,
      this.userInformation.personPhoneNumber,
      this.userInformation.personPhoneNumberExt?.toString() ?? '',
      this.userInformation.personAddress1,
      this.userInformation.personAddress2 ?? '',
      this.userInformation.personAddress3 ?? '',
      this.userInformation.personState,
      this.userInformation.personCity,
      this.userInformation.personZipCode?.toString() ?? '',
      this.userInformation.personCountryCode
    );

    this.checkZipCode(this.userInformation.personZipCode ?? 0, 1)
    this.validatedPhone = this.userInformation.personPhoneNumber;
    this.currentUserEmail = this.userInformation.email;
    if (!this.userInformation.personPhoneNumber) {
      this.form.setValid('personPhoneNumber', false);
    }
  }

   private checkZipCode(zip: number,init = 0): void {
        this.hasCorrectZipCode = false;         
        this.zipCodeLoading = true;         
        ZipCodeService.verifyZipCode(zip).then((res: any) => {
            if(res.cities.length > 0) {
                this.cities = res.cities
                let indexCurrentCity = this.cities.indexOf(this.userInformation.personCity);
                if(indexCurrentCity < 0)
                  this.form.set('personCity', this.cities[0])
            }
            this.form.personState.value = STATES.find((s: any) => String(s.state) === String(res.state)).name
            this.hasCorrectZipCode = true;
            this.form.setValid('personCity', true)
        }).catch(() => {
            this.form.personZipCode.valid = false
            this.form.setValid('personCity', false)
            this.form.setValid('personState', false)
            this.form.set('personCity', null)
            this.form.set('personState', null)

            this.form = {...this.form};
            this.$EdModal.createMessageModal(
                {
                title: i18n.t('tools.myInfo.userInformation'), 
                body: i18n.t('tools.myInfo.errorZipCodeBody'), 
                type: KEYS.EVENT_TYPES.DANGER
                });  
        }).finally(()=> {
            this.zipCodeLoading = false;
            if(init == 1) {
                this.initialForm = JSON.parse(JSON.stringify(this.form));
            }
        });
    }

    async findPerson(email) {
      if(this.currentUserEmail != this.form.email.value) {
        try {
          await this.$Auth.Services.existsEmail(email)
          this.$EdModal.createMessageModal(
            {
            body: `${this.$t('tools.myInfo.emailAlreadyExists', {email})}`, 
            action: async () => {
                this.form.set('email', '')
            },
            type: KEYS.EVENT_TYPES.WARNING,
            title: `${this.$t('tools.myInfo.reviewInfo')}`
            }
          );
          this.emailAlreadyExists = true;
        } catch(error) {
          this.emailAlreadyExists = false;    
        }
      }
    }

    async findPhone(phoneNumber) {
      if(phoneNumber != '' && this.userInformation.personPhoneNumber != phoneNumber) {
        try {
          await this.$Auth.Services.existsPhoneNumber(phoneNumber)
          this.$EdModal.createMessageModal(
            {
              body: this.$t('auth.register.errors.phoneAlreadyExists'), 
              title: this.$i18n.t('tools.myInfo.reviewInfo'),
              type: KEYS.EVENT_TYPES.WARNING,
              action: async () => {
                this.form.setValid('personPhoneNumber', false);
              }
            }
          );

          return false
        } catch(error) {
          return true
        }
      }

      return true
    }

    saveForm(): void {
        (this.$refs.EdLoading as any).show();
        let data: IUserInformation = {      
            personFirstName: this.form.personFirstName.value,
            personMiddleName: this.form.personMiddleName.value,
            personLastName: this.form.personLastName.value,
            personAddressId: this.userInformation.personAddressId,
            personAddress1: this.form.personAddress1.value,
            personAddress2: this.form.personAddress2.value,
            personAddress3: this.form.personAddress3.value,
            personPhoneId: this.userInformation.personPhoneId,
            personPhoneNumber: this.form.personPhoneNumber.value,
            personPhoneNumberExt: this.form.personPhoneNumberExt.value,
            personCountryCode: this.form.personCountryCode.value,
            personZipCode: this.form.personZipCode.value,
            personState: this.form.personState.value,
            personCity: this.form.personCity.value,
            email: this.form.email.value
        }
        
        MyInfoServices.updatePersonInformation(this.personId, data).then(() => {
            this.userInformation = data
            this.$EdToast.create({ 
                msg:  i18n.t('tools.myInfo.successChanges').toString(),
                type: TOAST_TYPES.SUCCESS,
                top: '3rem',
                timeout: 3000
            });
            this.setCurrentUserInformation(this.userInformation);
        }).catch(() => {
            this.$EdToast.create({ 
                msg:  i18n.t('tools.myInfo.unSuccessChanges').toString(),
                type: TOAST_TYPES.DANGER,
                top: '3rem',
                timeout: 3000
              });
        }).finally(() => {
          this.form = {...this.form};
          this.initialForm = JSON.parse(JSON.stringify(this.form));
          (this.$refs.EdLoading as any).hide();
        });
    }

    async validatePhoneModal() {
      if(this.verifyType != VERIFY_TYPES.TEXT_MESSAGE) {
        this.$EdModal.createMessageModal({
          title: this.$i18n.t('auth.register.headers.phone'),
          body: this.$i18n.t('auth.register.info.mustSelectVerifyMethod'),
          type: KEYS.EVENT_TYPES.WARNING,
        });
        return
      }
      if(!this.form.personPhoneNumber.value) {
         this.$EdModal.createMessageModal({
              title: this.$i18n.t('auth.register.headers.phone'),
              body: this.$i18n.t('auth.register.errors.phoneNoValid'),
              type: KEYS.EVENT_TYPES.WARNING,
            });
        return;
      }
      (this.$refs.EdLoading as any).show();
      let validPhone = await this.findPhone(this.form.personPhoneNumber.value);
      if(validPhone) {
        let response = await this.sendCode();
        response && this.$EdModal.createModal(EdRegisterValidatePhoneComponent, { 
          title: this.$i18n.t('tools.myInfo.phoneVerification'),
          phone: this.form.personPhoneNumber.value,
          verificationId: response.verificationId,
          getVerificationResponse: this.getVerificationResponse
        });
      }
      (this.$refs.EdLoading as any).hide();
    }
  
    public getVerificationResponse(verificationId, code) {
      this.form.set('personPhoneVerificationCode', code);
      this.form.setValid('personPhoneVerificationCode', true);
      this.form.set('personPhoneVerificationId', verificationId);
      this.form.setValid('personPhoneVerificationId', true);
      this.validatedPhone = this.form.personPhoneNumber.value;
    }
  
    public async sendCode() {    
      try {
        let response = await this.$Auth.Services.sendPhoneCode(this.form.personPhoneNumber.value);
        return response
      } catch (error) {
        this.$EdModal.createMessageModal({
          title: this.$i18n.t('auth.register.headers.phone'),
          body: error?.status === 429
            ? this.$i18n.t('auth.register.errors.phoneCodeRateLimited', { seconds: PUBLIC_RATE_LIMIT_WAIT_SECONDS.SMS_VERIFICATION })
            : this.$i18n.t('auth.register.errors.codeNotSent'),
          type: KEYS.EVENT_TYPES.WARNING
        });
        return false
      }
    }

    private setCurrentUserInformation(userInformation: IUserInformation): void {
      if (userInformation && this.$store.state.AuthStore.user) {
        const { id, userId, role } = this.$store.state.AuthStore.user;
        const updatedUserInfo: User = new User({
          id,
          userId,
          role,
          firstName: userInformation.personFirstName,
          lastName: userInformation.personLastName,
          email: userInformation.email
        });
        this.$store.commit(STORE.AUTH.MUTATIONS.SET_USER_INFO, updatedUserInfo);
      }
    }

  /* Hooks */
    async created() {
        const EdLoading: any = this.$refs.EdLoading; 
        this.personId = this.$Auth.Store.user.id
        this.username = this.$Auth.Store.user.userId
        this.init();
        await this.$store.dispatch(STORE.TOOLS.ACTIONS.GET_COUNTRIES);    
        this.userInformation = await MyInfoServices.getPersonInformationById(this.personId);
        this.setFields();
    }

}
